import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';

import Awards from '../../Block/Awards';

import ViewWithFilters from './ViewWithFilters';

const Block = ({ entity, totalPages }) => {
  const [blockType, blockId] = entity.getIn(['field_block_id', 0, 'value']).split(':');
  const [currentPage, setCurrentPage] = useState(0);

  // We only support view blocks for now.
  if (blockType === 'views') {
    // eslint-disable-next-line prefer-const
    let [viewId, viewDisplay] = blockId.split('-');
    const viewIdRewrite = {
      projectenlijst: 'projects',
      medewerkers: 'employees',
    };
    viewId = viewIdRewrite[viewId] || viewId;

    if (viewId === 'projects') {

      return (
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <ViewWithFilters id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} withHeader />
        </Fade>
      );
    }

    if (viewId === 'fonds_op_naam' || viewId === 'sia_projects') {
      return (
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <ViewWithFilters id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
        </Fade>
      );
    }

    return (
      <div>
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <View id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
        </Fade>
      </div>
    );
  }
  else if (blockType === 'custom') {
    const blockMapper = {
      toekenningen: Awards,
    };

    const ComponentType = blockMapper[blockId];
    if (!ComponentType) {
      return null;
    }

    return (
      <ComponentType />
    );
  }

  return null;
};

export default Block;
